import { render } from "./AudioUploader.vue?vue&type=template&id=4432f0d0&ts=true"
import script from "./AudioUploader.vue?vue&type=script&lang=ts"
export * from "./AudioUploader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__